import { app } from '../../app.module'
app
  // ブランド情報管理モーダル
  .directive('editBrandModal', () => {
    return {
      restrict: 'A',
      controller: ($scope, $rootScope, EditBrandModalService, $mdDialog) => {
        // モーダルに紐づけられたスコープから、必要な情報を取得
        const brandId: number = $scope.brandData.brandId

        // ブランド情報を初期化
        $scope.brandData = {
          brandId: brandId,
          brandName: '',
          groupIds: [],
          category: '',
          subCategory: '',
          registerUserName: '',
        }

        // 編集場合
        if (brandId !== undefined) {
          // つけられたフランドを取得
          EditBrandModalService.Brand.getBrandById(brandId).then((brandInfo) => {
            // フランドが存在する場合
            if (brandInfo !== null) {
              $scope.brandData.brandName = brandInfo.brandName
              $scope.brandData.category = brandInfo.brandCategoryName
              $scope.brandData.subCategory = brandInfo.brandSubCategoryName
              $scope.brandData.registerUserName =
                brandInfo.registerUserName != null ? brandInfo.registerUserName : '指定なし'

              let groupIds = []

              // グループIDリストがある場合、セット
              if (brandInfo.groupIds !== null) {
                groupIds = brandInfo.groupIds.split(',')
              }

              $scope.brandData.groupIds = groupIds
            }
          })
        }

        // サブカテゴリ変更のイベント
        $scope.$on('changeFilterData', (event, filterInfo) => {
          if (
            filterInfo.type === 'subCategoryFilter' &&
            filterInfo.subCategoryType === 'edit-category'
          ) {
            $scope.subCategoryName = filterInfo.value
          }
        })

        // ブランドが追加された際の処理
        $scope.saveBrandInfo = function () {
          // 編集モーダルを非表示にする
          $scope.isInput = false

          const brandInfo = {
            brandId: $scope.brandData.brandId,
            brandName: $scope.brandData.brandName,
            groupIds: $scope.brandData.groupIds,
            // 選択したメインカテゴリ、サブカテゴリをセット
            categoryName: $scope.categoryName,
            subCategoryName: $scope.subCategoryName,
            userId: $rootScope.userId,
          }

          // サーバーへPOSTする
          EditBrandModalService.Brand.saveBrand(brandInfo).then((result: { brandId: number }) => {
            // 新規追加したブランドに、新しい情報を付与する
            $scope.brandData.brandId = result.brandId
            $scope.brandData.category = $scope.categoryName
            $scope.brandData.subCategory = $scope.subCategoryName
            // ブランド情報が変更されたことを親スコープへ通知
            $scope.$emit('changeBrandsList')
            // 操作タイプを編集にする
            $scope.type = 'edit'
          })
        }

        // キャンセルボタンをクリックした際の処理
        $scope.cancelSave = function () {
          // 編集の場合
          if ($scope.type === 'edit') {
            // 編集モーダルを非表示にする
            $scope.isInput = false
          } else if ($scope.type === 'new') {
            // 新規作成の場合、モーダルを閉じる
            $mdDialog.hide()
          }
        }

        // ブランドを削除する処理
        $scope.deleteBrand = function () {
          // 確認メッセージ
          if (confirm('ブランドのデータが全て削除されます。本当に削除してよろしいですか?')) {
            // サーバーへPOSTする
            EditBrandModalService.Brand.deleteBrandById($scope.brandData.brandId).then(() => {
              // ブランド情報が削除されたことを親スコープへ通知
              $scope.$emit('changeBrandsList')
              // モーダルを閉じる
              $mdDialog.hide()
            })
          }
        }

        // モーダルを閉じる処理
        $scope.close = function () {
          $mdDialog.hide()
        }
      },
    }
  })
